// extracted by mini-css-extract-plugin
module.exports = {"view":"styles_view__3wA5H"};